import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_WALLET } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /consultation/doctor/wallet
export const fetchDoctorWalletReducer = createAsyncThunk(
  ACTION_DOCTOR_WALLET.fetch_doctor_wallet,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDoctorWallet}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        console.log("Doctor Wallet Response:", response.data.data);
        return response.data.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(message);
      }
    } catch (error) {
      console.error("Error fetching doctor wallet:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
